export var DEFAULT_SIMILAR_RESIDENTS_CONTROL = {
    items: [],
    openDemographics: false,
    setOpenDemographics: function () { },
    disableToggle: false,
    modal: null,
    isFetchingLinkedResident: false,
    isEditing: false,
    linkedResident: null,
    organizationId: "",
    isReadOnly: true,
};
